// extracted by mini-css-extract-plugin
module.exports = {"img":"FormattedImage_img__ai6L8"};